import React from 'react';
import {includes} from 'lodash';
import Icon from 'shared/components/icon';

interface Props {
  display: string;
  name?: string;
  status: string;
  image?: string;
}

const InvitedUser = ({display, name, status, image}: Props) => {
  let earned = false;

  const info = [
    <div key="invite-user-display" className="nav-bar-invite-user-display">
      {display}
    </div>,
  ];

  if (name) {
    info.unshift(
      <div key="invite-user-name" className="nav-bar-invite-user-name">
        {name}
      </div>
    );
  }

  if (includes(status, 'Earned')) {
    earned = true;
  }

  return (
    <div className="nav-bar-invite-user row">
      <div className="col-sm-1 col-xs-1">
        <span className="nav-bar-invite-user-avatar-container">
          <img className="nav-bar-invite-user-avatar" src={image} />
          {earned && (
            <span className="nav-bar-invite-user-avatar-overlay">
              <Icon className="nav-bar-invite-user-avatar-checkmark" iconType="check" />
            </span>
          )}
        </span>
      </div>
      <div className="col-sm-11 col-xs-11">
        <div className="nav-bar-invite-user-info">
          <span>{info}</span>
          <span className="nav-bar-invite-user-status">{status}</span>
        </div>
      </div>
    </div>
  );
};

export default InvitedUser;
